export const temporaryLink = [{
    // projectId: 125, // 项目编号
    projectId: 99997, // 项目编号
    projectName: '安波福-小时工项目',
    link: 'https://upoaz8.fanqier.cn/f/cfknieh8', // 跳转外部链接
  },{
    projectId: 99998, // 项目编号
    // projectId: 186, // 项目编号
    projectName: '嘉定奥托立夫-小时工项目',
    link: 'https://hfiri.fanqier.cn/f/3eebrph9', // 跳转外部链接
  },{
    projectId: 99999, // 项目编号
    // projectId: 88, // 项目编号
    projectName: '联钢-小时工项目',
    link: 'https://tuxg3.fanqier.cn/f/dlj8cajr', // 跳转外部链接
  }];